jQuery(document).ready(function($) {
  $('.file-input input[type="file"]').change(function(event) {
    var fileName = '';
    var button = $(this).closest('label');
    if( this.files && this.files.length > 1 ) {
      fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
    } else {
      fileName = event.target.value.split( "\\" ).pop();
    }

    if( fileName ) {
      button.find('div .text').html(fileName);
      button.append('<a href="#" class="clear">Clear</a>');
    } else {
      button.find('div .text').html('Choose a file');
      button.find('a').remove();
    }
  });

  $('body').on('click', '.file-input .clear', function(event) {
    event.preventDefault();
    $(this).closest('.file-input').find('input[type="file"]').val('').trigger('change');
  });

  $('body').on('click', '.checkboxes-hold .select-all-link', function(event) {
    event.preventDefault();
    $(this).closest('.checkboxes-hold').find('input[type="checkbox"]').prop("checked", true);
  });

  $('body').on('change', '.close-out-form input[name="all_tables"]', function(event) {
    event.preventDefault();
    check_show_tables(this);
  });

  if($('.close-out-form input[name="all_tables"]').length) {
    check_show_tables($('.close-out-form input[name="all_tables"]').last());
  }
});

function check_show_tables(check) {
  if($(check).prop("checked") == true) {
    $(check).closest('form').find('.table-numbers-hold').slideUp();
  } else {
    $(check).closest('form').find('.table-numbers-hold').slideDown();
  }
}